<script setup lang="ts">
  import { useSubjectResource } from '@/composables/useSubjectResource'

  import AnchorNavigationTask from '@/components/task/AnchorNavigationAssignment.vue'
  import FlytTask from '@/components/task/FlytTask.vue'
  import StepTaskAssignment from '@/components/task/StepTaskAssignment.vue'

  const props = defineProps<{
    contentId?: number
  }>()

  const {
    flytTasks,
    isAnchorNavigationTask,
    isLoading,
    subjectResource,
    stepTasks,
  } = useSubjectResource(props.contentId ?? undefined)
</script>

<template>
  <div
    v-if="!isLoading && (stepTasks.length || flytTasks.length)"
    class="focus-task-page"
  >
    <AnchorNavigationTask v-if="isAnchorNavigationTask" />

    <template v-if="!isAnchorNavigationTask && stepTasks && stepTasks.length">
      <StepTaskAssignment
        :tasks="stepTasks"
        :is-step-super-title="subjectResource?.isStepSuperTitle ?? false"
        :is-number-bullets="subjectResource?.isNumberBullets ?? false"
      />
    </template>
    <template v-if="!isAnchorNavigationTask && flytTasks && flytTasks.length">
      <FlytTask
        v-for="flytTask in flytTasks"
        :key="flytTask.contentId"
        :element="flytTask"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
  .focus-task-page {
    display: grid;
    grid-template-rows: auto 1fr auto;
    grid-template-areas: "header"
      "main"
      "footer";
    height: 100vh;

    @supports (height: 100svh) {
      height: 100svh;
    }

    :deep(header) {
      grid-area: header;
    }

    main {
      grid-area: main;

      @media (width <= 959px) {
        overflow-y: auto;
      }
    }

    height: 100%;

    &:has(.task-frontpage) {
      overflow: hidden;
    }

    &__overlay {
      position: fixed;
      background-color: rgb(0 0 0 / 40%); // Shame
      height: 100vh;
      width: 100vw;
      z-index: 5;
    }
  }
</style>
